<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-01-05 18:58:01
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-01-19 10:12:12
 * @FilePath: /chaoyongtuan/src/views/secondColonelManage/components/updateTime.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="update-time flex flex-align-center">
		<el-button class="mr-8" @click="updateFun">更新列表</el-button>
		<p class="yx-color-text-regular fz-13 mr-10 time">更新时间: {{ sync_time || '--' }}</p>
		<el-tooltip class="item" effect="dark" content="手动更新后有10min左右延迟，请主动刷新页面更新数据" placement="top">
			<i class="iconfont icon-a-help-circle-obangzhu-xian yx-color-info fz-12 help mr-4"></i>
		</el-tooltip>
	</div>
</template>
<script>
import { getSyncTime } from '@/api/secondColonelManage';
export default {
	props: {
		type: {
			type: String,
			default: () => '1',
		},
	},
	data() {
		return {
			sync_time: '',
		};
	},
	methods: {
		async updateFun() {
			this.$emit('updateList');
		},
		async getSyncTime(third_activity_id, platform_id = '') {
			const { type } = this;
			let params = third_activity_id ? { item_id: third_activity_id } : {};
			const { code, data } = await getSyncTime({ type, ...params, platform_id });
			if (code !== 0) return;
			this.sync_time = data.sync_time || '-';
		},
	},
};
</script>
<style lang="less" scoped>
.multi-table {
	position: relative;
	.update-time {
		position: absolute;
		right: 24px;
		z-index: 1000;
	}
}
.help {
	margin-top: 2px;
	margin-right: 2px;
}
</style>
